import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingActionButton from "./FloatingActionButton";

/**
 * Layout: Wrapper component that provides consistent structure for all pages
 * - Outlet renders the current page component (from App.tsx routes)
 * - Includes Header, Footer, and "back to top" button
 * - Used as the parent route in App.tsx, so all pages share this layout
 */
const Layout: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'  // Smooth scroll animation
    });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      {/* flex-1 makes main content take remaining space, pushing footer down */}
      <main className="flex-1">
        {/* Outlet: Renders the matched child route component (HomePage, AboutPage, etc.) */}
        <Outlet />
      </main>
      <Footer />
      {/* Floating button appears when scrolled down, scrolls to top on click */}
      <FloatingActionButton onClick={scrollToTop}>
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </FloatingActionButton>
    </div>
  );
};

export default Layout; 